import React from 'react';
import { useParams, useHistory, generatePath } from 'react-router-dom';
import { DecisionTimeDetails } from 'components/BonusCardDetails';
import routes from 'constants/routes';

import { BonusStatus, BonusIdentifier } from 'constants/appEnums';

import NewSigning from '../NewSigning';
import Error from '../Error';

const BonusDetails = () => {
  const params: { [key: string]: string } = useParams();
  const history = useHistory();

  const handleOnActivateClick = () => {
    if (params.bonusType === BonusIdentifier.DecisionTime) {
      history.push(
        generatePath(routes.DECISION_TIME.route, {
          bonusType: BonusIdentifier.DecisionTime
        })
      );
    }
  };

  // TO-DO: link higher level components that will take user through each bonus types unlocking process based on api data / redux state
  switch (params.bonusType) {
    case BonusIdentifier.NewSigning:
      return <NewSigning />;
    case BonusIdentifier.DecisionTime:
      return <DecisionTimeDetails bonusState={BonusStatus.available} onActivateClick={handleOnActivateClick} />;

    default:
      return <Error />;
  }
};

export default BonusDetails;
